export default __webpack_public_path__ + "static/media/close-x-black.c2840dc2.svg";